import { render, staticRenderFns } from "./zhenliao-edit.vue?vue&type=template&id=6f90cc64&scoped=true&"
import script from "./zhenliao-edit.vue?vue&type=script&lang=ts&"
export * from "./zhenliao-edit.vue?vue&type=script&lang=ts&"
import style0 from "./zhenliao-edit.vue?vue&type=style&index=0&id=6f90cc64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90cc64",
  null
  
)

export default component.exports